import React from "react";
import { LocaleLink } from "../../i18n/LocaleLink";
import { blogDetailsPath } from "../../data/blogs";

export const BlogAreaThreeItem = ({ blog }) => {
  const detailsTo = blogDetailsPath(blog.id);

  return (
    <div className="blog-post-item-two">
      <div className="blog-post-thumb-two">
        <LocaleLink to={detailsTo}>
          <img src={blog.src} alt="" />
        </LocaleLink>
        <LocaleLink to={blog.tagHref} className="tag tag-two">
          {blog.tag}
        </LocaleLink>
      </div>
      <div className="blog-post-content-two">
        <h2 className="title">
          <LocaleLink to={detailsTo}>{blog.title}</LocaleLink>
        </h2>
        <p>{blog.subtitle}</p>
        <div className="blog-meta">
          <ul className="list-wrap">
            <li>
              <LocaleLink to={detailsTo}>
                <img src={blog.authorSrc} alt="" />
                {blog.author}
              </LocaleLink>
            </li>
            <li>
              <i className="far fa-calendar"></i>
              {blog.createdAt}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
